<template>
  <span class="text-center">
    <span v-text="valueText" :class="valueClass" />
  </span>
</template>

<script>

export default {
  props: {
    value: {
      type: Number,
      required: true,
    },

    // factor to multiply the value with
    scale: {
      type: Number,
      default: 1,
    },

    // number of fraction digits
    precision: {
      type: Number,
      default: 0,
    },

    // if set, values lower than this value are displayed as "< [threshold]"
    threshold: {
      type: Number,
      coerce: (str) => parseInt(str),
    },

    // if set, value '0' is shown
    showZero: {
      type: Boolean,
      default: false,
    },

    // if set, positive values are prefixed with '+ '
    showPlus: {
      type: Boolean,
      default: false,
    },

    // if set, the value is formatted with current locale
    localized: {
      type: Boolean,
      default: false,
    },

    // if set, the value is shown as a green or red chip
    chip: {
      type: Boolean,
      default: false,
    },

    chipColor: {
      type: String
    },

    // additional style classes to apply
    styles: {
      type: String,
    },

    
  },

  computed: {
    valueText() {
      if (!this.value || this.value.isNaN) {
        return "";
      }
      if (this.value == 0) {
        return this.showZero ? "0" : "";
      }
      // compute scaled value
      let number = this.value * this.scale;
      let lowerThanThreshold = this.threshold
        ? Math.abs(number) < this.threshold
        : false;

      // handle fraction digits and localization
      if (lowerThanThreshold) {
        number = this.threshold;
      }
      let numberAsText = this.localized
        ? Math.abs(number).toLocaleString(this.$i18n.locale, {
            maximumFractionDigits: this.precision,
          })
        : "" + Math.abs(number).toFixed(this.precision);

      // finally, decide if positive numbers are prefixed with "+" and if "0" is displayed or not
      if (lowerThanThreshold) {
        return "< " + (this.value < 0 ? "-" : "") + numberAsText;
      }
      if (this.value > 0) {
        return this.showPlus ? "+ " + numberAsText : numberAsText;
      } else {
        return "- " + numberAsText;
      }
    },

    valueClass() {
      if (!this.value || this.value.isNaN) {
        return "";
      }

      let styleClasses = "formatted-value";
      if (this.styles) {
        styleClasses += this.styles;
      }

      if (this.chip) {
        styleClasses += " formatted-value__chip";
       
        if(this.chipColor) {
          styleClasses += " formatted-value__"+this.chipColor;
        } 
        else {
          if (this.value >= 0) {
            styleClasses += " formatted-value__green";
          } 
          else {
            styleClasses += " formatted-value__red";
          }
        }
      }
      return styleClasses;
    },
  },
  
};
</script>
